import { Component } from 'react';
import { COLUMNS } from './keys';
import Loading from '../../../components/Loading';
import { getData } from './query';
import DataTable from '../../../components/Datatable';
import Message from '../../Message';
import { getSortKeys, setAdditionalStyles } from '../../../helpers/table';
import { getProjects } from '../create/query';
import { withTranslation } from 'react-i18next';
import MessageCutom from '../../../components/MessageCustom';
import AdditionalBox from './additionalBox';

class PromptManager extends Component {
    constructor() {
        super();

        this.deleteMessage = this.deleteMessage.bind(this);
        this.searchFunction = this.searchFunction.bind(this);
        this.getPrompts = this.getPrompts.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onRemoveAllSelected = this.onRemoveAllSelected.bind(this);
        this.handleSelectProject = this.handleSelectProject.bind(this);
        this.handleSelectStatus = this.handleSelectStatus.bind(this);

        this.urlParams = new URLSearchParams(window.location.search);

        this.tab = this.urlParams.get('tab');

        this.defaultTab = this.tab ?? 'entities';

        sessionStorage.removeItem('ai_tracking_message');
        this.state = {
            data: [],
            message: '',
            message_tags: '',
            removeAllSelected: false,
            selectedItems: [],
            selectedProject: null,
            sortedData: [],
            selectedStatus: null,
        };
    }

    async getPrompts() {
        try {
            this.setState({ loading: true });
            const response = await getData();
            const data = await response.json();
            this.setState({ loading: false, data, sortedData: data });
        } catch (err) {
            console.log(err);
            this.setState({ loading: false });
        }
    }

    async componentDidMount() {
        this.getPrompts();
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter(
            (item) =>
                item.prompt?.toLowerCase().includes(search.toLowerCase()) ||
                `${item.country} - ${item.language}`.toLowerCase().includes(search.toLowerCase()) ||
                item.project?.name?.toLowerCase().includes(search.toLowerCase()),
        );
    }

    handleSelectProject(value) {
        if (value === 'all') {
            if (this.state.selectedStatus !== 'all') {
                this.handleSelectStatus(this.state.selectedStatus);
                return;
            }
            this.setState({ selectedProject: value, sortedData: this.state.data });
            return;
        }
        this.setState({ selectedProject: value });
        const data = this.state.data.filter(
            (item) =>
                item.project?.id === value &&
                (this.state.selectedStatus ? item?.status === this.state.selectedStatus : true),
        );
        this.setState({ sortedData: data });
    }

    handleSelectStatus(value) {
        if (value === 'all') {
            this.setState({ selectedStatus: value, sortedData: this.state.data });
            return;
        }
        const data = this.state.data.filter((item) => {
            return (
                item?.status === value &&
                (this.state.selectedProject
                    ? item?.project?.id === this.state.selectedProject
                    : true)
            );
        });
        this.setState({ selectedStatus: value, sortedData: data });
    }

    deleteMessage() {
        this.setState({ message: '', message_tags: '' });
    }

    onSelect(action, state) {
        if (action.type === 'REMOVE_ALL') return this.setState({ selectedItems: [] });
        this.setState({ selectedItems: state.ids, removeAllSelected: false });
    }

    onRemoveAllSelected(bool) {
        this.setState({
            removeAllSelected: bool,
            selectedItems: [],
        });
    }

    render() {
        const { t } = this.props;

        const additionalBox = () => (
            <AdditionalBox
                t={t}
                onRemoveAllSelected={this.onRemoveAllSelected}
                selectedItems={this.state.selectedItems}
                getPrompts={this.getPrompts}
                handleSelectProject={this.handleSelectProject}
                selectedProject={this.state.selectedProject}
                projects={this.props.projects}
                projectLoader={this.props.projectLoader}
                handleSelectStatus={this.handleSelectStatus}
                selectedStatus={this.state.selectedStatus}
            />
        );

        return (
            <>
                <div className="card table-main rounded-main ">
                    <div>
                        {this.state.loading && <Loading padding={10} />}
                        {!this.state.loading && (
                            <DataTable
                                nodes={this.state.sortedData ?? []}
                                sortFns={getSortKeys(COLUMNS(t))}
                                searchFunction={this.searchFunction}
                                COLUMNS={COLUMNS(t, this.getPrompts, this.props.projects)}
                                defaultSortKey={'keyword_uid'}
                                additionalBox={additionalBox}
                                customEmptyMessage={t('global.no_data')}
                                hasSelect={true}
                                onSelect={this.onSelect}
                                removeAllSelected={this.state.removeAllSelected}
                                additionalStyles={setAdditionalStyles(COLUMNS(t), true)}
                            />
                        )}
                    </div>{' '}
                </div>
                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={this.state.message_tags ?? 'info'}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                            time={8000}
                        />
                    </div>
                )}
            </>
        );
    }
}

export default withTranslation()(PromptManager);
